import { auth, sendUsername, getShowCaptcha, getProfile, getAcceptTerms, logoff, editPassword, getApiUrl } from '@/services/authentication';
import Axios from 'axios';
import router from '@/router';
import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  getApiUrl: async ({ commit, dispatch }) => {
    const { data } = await getApiUrl();

    Axios.defaults.baseURL = `${data.API_URL}/api`;

    if (data) commit('setConfig', data);

    await dispatch('layout/getConfigLayout', null, { root: true });
  },

  sendUsername: async ({ commit, state }, { userName }) => {
    try {
      const { data } = await sendUsername(userName);

      const { data: getCaptcha } = await getShowCaptcha(userName);

      commit('setCaptcha', getCaptcha);

      commit('setGuid', data);

      return data;
    } catch (err) {
      console.error(err);
    }
  },

  login: async ({ commit, state, rootState }, { password, guid }) => {
    try {
      eventBus.$emit(HANDLERS.INIT_LOADING);

      const { data } = await auth(password, guid);

      localStorage.setItem(state.config.VUE_APP_TOKEN_KEY, data.access_token);

      const { data: profile } = await getProfile();

      if (profile.isAcceptTerms) {
        const { data: message } = await getAcceptTerms();

        commit('userNotAcceptTerms', {
          isAcceptTerms: profile.isAcceptTerms,
          acceptTermsMessage: message.description
        });

        return;
      }

      await commit('loginSuccess', profile);

      if (rootState.authentication.config.DEV_MODULE) {
        router.push({ path: '/dev' });
      } else {
        router.push({ path: '/dashboard' });
      }
    } catch (err) {
      commit('logoff');
    } finally {
      eventBus.$emit(HANDLERS.FINISH_LOADING);
    }
  },

  logoff: async ({ commit, state }) => {
    try {
      await logoff();

      await commit('logoff');

      router.push({ path: '/login' });
    } catch (err) {
      commit('logoff');
    }
  },

  getProfile: async ({ commit }) => {
    try {
      const { data } = await getProfile();
      await commit('loginSuccess', data);

      return data;
    } catch (err) {
      commit('logoff');
    }
  },

  getAcceptTerms: async ({ commit }) => {
    try {
      const { data } = await getAcceptTerms();

      return data;
    } catch (err) {
      commit('logoff');
    }
  },

  editPassword: async ({ dispatch }, { newPassword, newPasswordConfirmation }) => {
    const { status } = await editPassword(newPassword, newPasswordConfirmation);

    dispatch(
      'notification/showNotification',
      {
        color: status === 204 ? 'success' : 'error',
        text: status === 204 ? 'Senha alterada com sucesso.' : 'Erro ao alterar a senha!',
        showIconNotification: false
      },
      { root: true }
    );
  }
};
